import { useComposerSpace } from "@circle-react/components/QuickPostV3/hooks/useComposerSpace";
import { Icon } from "@circle-react/components/shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circleco/compass/components/Typography";
import { truncate } from "lodash";
import type { ButtonHTMLAttributes } from "react";
import { forwardRef } from "react";

import { t } from "@/i18n-js/instance";

export interface SpaceTriggerProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  "data-popup-open"?: string;
  isMd: boolean;
}

export const SpaceTrigger = forwardRef<HTMLButtonElement, SpaceTriggerProps>(
  ({ isMd, "data-popup-open": dataPopupOpen, className, ...props }, ref) => {
    const { space: selectedSpace } = useComposerSpace();
    const isOpen =
      props["aria-expanded"] === true ||
      props["aria-expanded"] === "true" ||
      dataPopupOpen !== undefined;

    return (
      <button
        ref={ref}
        type="button"
        className={classNames(
          "focus-visible:bg-secondary hover:bg-secondary flex w-full cursor-pointer items-center rounded-md",
          {
            "bg-secondary": isOpen,
            "px-5 py-4": !isMd,
            "px-0 py-0": isMd,
          },
          className,
        )}
        data-popup-open={dataPopupOpen}
        {...props}
      >
        <div
          className={classNames("flex min-w-0 items-center gap-1", {
            "flex-1": !isMd,
          })}
        >
          <Typography variant="label-sm" color="secondary" component="span">
            {selectedSpace?.name ? (
              <>
                {t("quick_post_v2.posting_in")}{" "}
                <Typography
                  variant="label-sm"
                  color="primary"
                  component="span"
                  title={selectedSpace.name}
                >
                  {truncate(selectedSpace.name, {
                    length: isMd ? 24 : 36,
                  })}
                </Typography>
              </>
            ) : (
              <Typography variant="label-sm" color="tertiary" component="span">
                {t("quick_post_v2.choose_a_space")}
              </Typography>
            )}
          </Typography>
        </div>
        <Icon className="!text-dark" type="16-chevron-down" size={16} />
      </button>
    );
  },
);

SpaceTrigger.displayName = "SpaceTrigger";
